import { ViewItem } from './itemModel'
import InvoicedIcon from './InvoicedIcon'
import { ActualItemOrigins } from '../../common/constants'
import { Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'

type Props = {
  item: ViewItem
  showVisitWorkareaName: boolean
}
export const VisitDetail = ({ item, showVisitWorkareaName }: Props) => {
  const workarea = showVisitWorkareaName ? <strong>{item.workareaName}<br /></strong> : ''

  const formatDate = (date: string): string => {
    return new Date(date).toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' })
  }
  const buildVisit = () => {
    if (!item.visit) {
      return
    }
    const check = item.visit.billed
      ? <Tooltip title="This visit has been reviewed"><FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} /></Tooltip>
      : <></>

    return <>{check}{`${formatDate(item.visit.date)} visit added by ${item.visit?.owner}`}</>
  }

  const buildOrigin = () => {
    if (item.originOwner) {
      if (item.origin === ActualItemOrigins.Receipt) {
        return `Receipt item added by ${item.originOwner}`
      }

      const datePart = item?.webEntryConsumptionDate
        ? `${formatDate(item.webEntryConsumptionDate)} w`
        : 'W';

      return `${datePart}eb item added by ${item.originOwner}`;
    }

    if (item.origin === ActualItemOrigins.Receipt) {
      return 'New receipt item'
    }
    return 'New web entry'
  }

  const createdBy = buildVisit() ?? buildOrigin()

  return <div>
    <InvoicedIcon item={item} />
    {workarea}
    {createdBy}
  </div>

}

export default VisitDetail
